import React from "react";
import { Link } from "react-router-dom";

function ThirtyDaysOfCode() {
  return (
    <>
      <div className="code-hero-section text-center text-white ">
        <div className="container mt-5 ">
          <h1 className="display-4 font-weight-bold ">30 DAYS OF CODE</h1>
          <h1 className="lead mt-3 ">
            Your Pathway To Your Dream Tech Future
          </h1>

          <div className="search-bar mb-4 mt-4 d-flex justify-content-center ">
            <form className="form-class form-inline justify-content-center">
              <input
                className="form-control"
                type="text"
                placeholder="Technology"
              />

              <select className="form-control-type">
                <option value="">Select Level</option>
                <option value="beginner">Beginner</option>
                <option value="intermediate">Intermediate</option>
                <option value="advanced">Advanced</option>
              </select>

              <button className="btn btn-dark" type="submit">
                Search
              </button>
            </form>
          </div>
          
          <h1 className="batch-lead mb-4 mt-5  ">
            Batch Registrations Are Opening Soon
          </h1>

          <Link to={'#'} className="btn btn-primary btn-lg mt-3 mb-5 ">
            Sign Up Today
          </Link>
          
        </div>
      </div>
    </>
  );
}

export default ThirtyDaysOfCode;
